import { Component, Input, OnInit } from '@angular/core';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { StaffService } from '@ascschool/services/user/staff.service';
@Component({
  selector: 'app-popup-ttns',
  templateUrl: './popup-ttns.component.html',
  styleUrls: ['./popup-ttns.component.scss']
})
export class PopupTtnsComponent implements OnInit {
  typeOfPersonnel: number;
  formType: number;
  @Input() id;
  @Input() value;
  typeOfPersonnels: TypeOfPersonnelRadio[];
  commonFilter = new CommonFilter();
  constructor(private staffService: StaffService, private typeOfPersonnelService: TypeOfPersonnelService) { }
  ngOnInit() {
    this.loadTypeofPersonnel();
    this.getById(this.value.id);

  }
  getById(id) {
    this.staffService.getById(id).subscribe((res) => {
      this.typeOfPersonnel = res.typeOfPersonnel;
      this.formType = res.formType;
    });
  }

  loadTypeofPersonnel() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = 200;
    this.typeOfPersonnelService.getTypeOfPersonnelSelectPaging(this.commonFilter).subscribe((res: any) => { 
      if (res.results !== null) {
        this.typeOfPersonnels = res.results;
        this.typeOfPersonnels = this.typeOfPersonnels.sort((a, b) => (a.displayOrder < b.displayOrder ? -1 : 1));
        let item = this.typeOfPersonnels[0];
        this.formType = item.formType;
        // this.getRadioItems(this.typeOfPersonnel);
      }
    });
  }

  onChangeStatus(event: any): void { 
    this.getRadioItems(event);
  }

  getRadioItems(id: any): void {
    let selectRadio = this.typeOfPersonnels.find(x => x.id === id);
    this.formType = selectRadio.formType; 
  }
}

interface TypeOfPersonnelRadio {
  id: number;
  typeOfPersonnelName: string;
  formType: number;
  displayOrder: number;
}
